// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__Bgf6X","loader":"Loader_loader__1S3wc"};